<mat-form-field class="multi_select_inpt" appearance="fill" [class]="customClasses">
  <!-- Label -->
  <mat-label [class.custom-label]="true"
    >{{ placeholder }}
    <span class="required" *ngIf="showCustomRequiredMark && !customOptions"></span>
  </mat-label>

  <!-- Select -->
  <mat-select
    #dropdown
    [formControl]="selectControl"
    [multiple]="multiple"
    (opened)="searchInput.focus()"
    (selectionChange)="onSelectChange($event)">
    <!-- If Custom Option Added -->
    <mat-select-trigger class="static-content" *ngIf="customOptions"> </mat-select-trigger>

    <!-- If Normal Selected Value Preview -->
    <mat-select-trigger class="static-content" *ngIf="!customOptions && !multiple">
      <div class="d-flex justify-content-between">
        <p class="option-name pe-1">{{ isTextCamelCase ? (getName() | camelCase) : getName() }}</p>

        <div
          class="custom_icon"
          *ngIf="showClear && !disabled"
          (click)="$event.preventDefault(); $event.stopPropagation(); onClickClearSelection()">
          <i class="demo-class icon-close"></i>
        </div>
      </div>
    </mat-select-trigger>

    <!-- If multiselection -->
    <mat-select-trigger *ngIf="multiple && !customOptions">
      <mat-chip-row class="me-1" (removed)="onOptionRemoved(option)" *ngFor="let option of selectedOptions">
        {{ isTextCamelCase ? (option[getDisplayFieldName()] | camelCase) : option[getDisplayFieldName()] }}
        <button class="chip_close" matChipRemove>
          <i class="demo-icon icon-close"></i>
        </button>
      </mat-chip-row>
    </mat-select-trigger>

    <!-- Search -->
    <div [ngClass]="{ 'hide-search': !searchable }">
      <form class="drop-down-search" [formGroup]="dropDownForm">
        <input
          [placeholder]="('shared.Search' | translate) + '...'"
          #searchInput
          formControlName="search"
          (keydown.space)="$event.stopPropagation()" />
        <div class="search_close" *ngIf="dropDownForm.get(['search'])?.value?.length > 0">
          <i class="demo-class icon-close" (click)="onClickClear()"></i>
        </div>
      </form>
    </div>

    <ng-container *ngIf="showLoading && !dataLoaded; else optionsDisplay">
      <mat-option disabled style="padding-bottom: 5px"> <skelton-loader height="30px"></skelton-loader></mat-option>
      <mat-option disabled style="padding-bottom: 5px"> <skelton-loader height="30px"></skelton-loader></mat-option>
      <mat-option disabled style="padding-bottom: 5px"> <skelton-loader height="30px"></skelton-loader></mat-option>
    </ng-container>

    <ng-template #optionsDisplay>
      <div class="options" [ngClass]="{ 'custom-option': customOptions, 'drop-height': !searchable }">
        <ng-container *ngFor="let option of options">
          <mat-option
            [value]="valueField && valueField !== '' ? option[valueField] : option"
            (click)="onClickOptions($event)"
            [disabled]="optionDisabled"
            [ngStyle]="{
              display:
                checkIfIdExists(valueField && valueField !== '' ? option[valueField] : option) === false
                  ? 'none'
                  : 'flex'
            }">
            <!-- If Custom Button is Added -->
            <div
              class="w_100 d-flex align-items-center justify-content-between"
              (click)="$event.stopPropagation(); option.isAdded ? '' : onClickAddItem(option)"
              *ngIf="customOptions; else optionTitle">
              <span class="item-title"
                >{{ isTextCamelCase ? (option[getDisplayFieldName()] | camelCase) : option[getDisplayFieldName()] }}
              </span>

              <!-- Added Button -->
              <button
                mat-flat-button
                (click)="$event.preventDefault(); $event.stopPropagation()"
                *ngIf="option.isAdded; else addItemButton">
                {{ 'shared.Added' | translate }}
              </button>

              <!-- Add Button -->
              <ng-template #addItemButton>
                <button class="add-btn" mat-flat-button (click)="$event.stopPropagation(); onClickAddItem(option)">
                  {{ 'shared.Add' | translate }}
                </button>
              </ng-template>
            </div>

            <!-- If Normal Option -->
            <ng-template #optionTitle class="item-title">
              {{ isTextCamelCase ? (option[getDisplayFieldName()] | camelCase) : option[getDisplayFieldName()] }}
            </ng-template>
          </mat-option>
        </ng-container>
        <!-- If Option list is empty -->
        <mat-option disabled *ngIf="optionsSearched?.length === 0">
          {{
            option
              ? ('shared.No' | translate) + ' ' + option + ' ' + ('shared.Found' | translate)
              : ('shared.No_Option_Found' | translate)
          }}
        </mat-option>
      </div>
    </ng-template>
  </mat-select>

  <!-- Hint -->
  <mat-hint [class]="hintType" *ngIf="isShowHint">{{ hint }}</mat-hint>
</mat-form-field>
